import {
  Dialog,
  DialogContent,
  useMediaQuery,
  Box,
  Chip,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { Position } from '@staffedupusa/shared-components';
import { lightGrey } from '@styles/colors';
import { light, medium } from '@styles/fontWeights';
import theme from '@styles/theme';
import { FC } from 'react';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PlaceIcon from '@mui/icons-material/Place';
import { formSalaryString, getPositionStatusDescription } from '../utils';
import { updatedPositionTypes } from '@features/jobPostings/constants';

type AboutJobPostingModalProps = {
  isOpen: boolean;
  templateJob?: boolean;
  handleClose: () => void;
  jobPosting: Position | null;
};

const AboutJobPostingModal: FC<AboutJobPostingModalProps> = ({
  isOpen,
  templateJob,
  handleClose,
  jobPosting: position,
}) => {
  const isSmOrHigher = useMediaQuery(theme.breakpoints.up('sm'));

  if (!position) {
    return null;
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogContent
        sx={{
          padding: 0,
        }}
      >
        <Box paddingX={4} paddingY={3} bgcolor={lightGrey}>
          <Box>
            <Box display="flex" alignItems="center">
              <Typography display="inline-block" variant="h3" mr={2}>
                {position.s_title}
              </Typography>
              <Chip
                label={getPositionStatusDescription(position.status)}
                size="small"
                color={position.status === 3 ? 'success' : 'primary'}
              />
            </Box>
            {!templateJob && <Typography>{position.company.s_name}</Typography>}
          </Box>
          <Stack
            paddingY={2}
            spacing={2}
            direction={{
              xs: 'column',
              sm: 'row',
            }}
            divider={
              <Divider
                data-testid="divider"
                orientation={isSmOrHigher ? 'vertical' : 'horizontal'}
                flexItem
              />
            }
            justifyContent={{
              xs: 'center',
              sm: 'left',
            }}
            sx={{
              fontSize: '15px',
              fontWeight: light,
            }}
          >
            {!templateJob && (
              <Stack direction="row" spacing={2} alignItems="center">
                <PlaceIcon fontSize="large" />
                <Box>
                  {position.company.s_address1 && (
                    <Typography fontSize="inherit" fontWeight="inherit">
                      {position.company.s_address1}.
                    </Typography>
                  )}
                  <Typography fontSize="inherit" fontWeight="inherit">
                    {`${position.company.s_city}, ${position.company.s_state} ${position.company.s_zip}`}
                  </Typography>
                </Box>
              </Stack>
            )}
            <Stack
              sx={{ maxWidth: '270px' }}
              direction="row"
              spacing={2}
              alignItems="center"
            >
              <MonetizationOnIcon fontSize="large" />
              <Typography fontSize="inherit" fontWeight="inherit">
                {formSalaryString(position)}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography
                fontSize="inherit"
                fontWeight="inherit"
                textTransform="uppercase"
              >
                Position Type:
              </Typography>
              <Typography fontSize="inherit" fontWeight="inherit">
                {updatedPositionTypes?.find(
                  (item) =>
                    item.value ===
                    (position.s_type === 'Singe Event'
                      ? 'Single Event'
                      : position.s_type),
                )?.label || 'Not specified'}
              </Typography>
            </Stack>
          </Stack>
        </Box>
        <Box paddingX={4} paddingY={2}>
          <Typography fontWeight={medium} fontSize="22px">
            Description
          </Typography>
          <Box dangerouslySetInnerHTML={{ __html: position.s_description }} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AboutJobPostingModal;
